import { useContext } from 'react';
import QuestionnaireContext from '../context/QuestionnaireContext';

export const useQuestionnaireContext = () => {
  const context = useContext(QuestionnaireContext);
  return context;
};
